import Link from 'next/link';

import { useClientQueries } from '@/src/assets/hooks/useClientQueries';
import { footerQuery } from '@/src/assets/queries/footerQuery';
import { IFooter } from '../../../assets/interfaces/footerInterface/index';

import Logo from '../Logo/Logo';
import Wrapper from '../../UI/wrapper/Wrapper';
import styles from './Footer.module.scss';
import NextImage from '../../UI/nextImage/NextImage';

import rating from '@/public/21+.svg';

import mgcb from '@/public/mgcb.png';
import dge from '@/public/dge.png';
import pgcb from '@/public/pgcb.png';

import usaToday from '@/public/usaToday.svg';
import fourfourtwo from '@/public/fourfourtwo.svg';
import liveStore from '@/public/liveScore.svg';
import nj from '@/public/nj.svg';

import PortableBlock from '../../UI/portableBlock/PortableBlock';

const Footer = () => {
  const { data } = useClientQueries(footerQuery);

  const footerData: IFooter | null = data ? data : null;

  return (
    <footer className={styles.footer}>
      <Wrapper className={styles.wrapper}>
        <div className={styles.footer__top}>
          <div className={styles.footer__logo}>
            <Logo
              className={styles.logotype}
              sizes={'(max-width: 360px) 130px, (max-width: 1024px) 140px, 150px)'}
            />
            {data && <p className={styles.logo__descr}>{footerData!.siteTagline}</p>}
          </div>
          <nav className={styles.menu}>
            <ul className={styles.menu__list}>
              {data &&
                footerData!.topMenu.map((item, i) => {
                  const target = item.internalLink?.newWindow
                    ? '_blank'
                    : item.externalUrl?.newWindow
                    ? '_blank'
                    : undefined;
                  return (
                    <li key={`${item._key}-${i}`} className={styles.menu__item}>
                      <Link
                        href={
                          item.internalLink?.link
                            ? `/${item.internalLink.link}`
                            : item.externalUrl?.url ?? '/'
                        }
                        target={target}
                        rel={target ? 'noopener noreferrer' : undefined}>
                        {item.menuItemName}
                      </Link>
                    </li>
                  );
                })}
            </ul>
          </nav>
        </div>
        <nav className={styles.nav}>
          {data &&
            footerData!.menu.map((item) => {
              return (
                <ul key={item._key} className={styles.nav__list}>
                  <li className={styles.nav__heading}>{item.menuItemName}</li>
                  <>
                    {item.menuItemList.map((listItem) => {
                      const target = listItem.internalLink?.newWindow
                        ? '_blank'
                        : listItem.externalUrl?.newWindow
                        ? '_blank'
                        : undefined;
                      return (
                        <li key={listItem._key} className={styles.nav__item}>
                          <Link
                            href={
                              listItem.internalLink?.link
                                ? `${listItem.internalLink.link}`
                                : listItem.externalUrl?.url ?? '/'
                            }
                            target={target}
                            rel={target ? 'noopener noreferrer' : undefined}>
                            {listItem.menuItemName}
                          </Link>
                        </li>
                      );
                    })}
                  </>
                </ul>
              );
            })}
        </nav>
        <div className={styles.footer__bottom}>
          <div className={styles.bottom__left}>
            <div className={styles.rating}>
              <NextImage src={rating} alt="21+" width={40} height={40} loading='lazy'/>
              <div>
                <p>Gambling Problem? </p>
                <p>Call 1-800-GAMBLER</p>
              </div>
            </div>

            <div className={styles.description}>
              {data && <PortableBlock value={footerData!.copyright[0]} />}
            </div>

            <div className={styles.licensed}>
                <span>Licensed by:</span>
                <NextImage 
                    width={46}
                    height={38}
                    src={mgcb.src}
                    alt="MGCB"
                    loading='lazy'
                />
                <NextImage 
                    width={46}
                    height={44}
                    src={dge.src}
                    alt="DGE"
                    loading='lazy'
                />
                <NextImage 
                    width={44}
                    height={44}
                    src={pgcb.src}
                    alt="MGCB"
                    loading='lazy'
                />
            </div>
          </div>
          <div className={styles.bottom__line}></div>
          <div className={styles.bottom__center}>
            <p>Featured In:</p>
            <div className={styles.logos__block}>
              <div className={styles.logo}>
                <NextImage src={usaToday} alt="USAToday" fill sizes="74.4px" loading='lazy'/>
              </div>
              <div className={styles.logo}>
                <NextImage src={fourfourtwo} alt="FourFourTwo" fill sizes="117px" loading='lazy'/>
              </div>
              <div className={styles.logo}>
                <NextImage src={liveStore} alt="liveStore" fill sizes="120px" loading='lazy'/>
              </div>
              <div className={styles.logo}>
                <NextImage src={nj} alt="NJ" fill sizes="50px" loading='lazy'/>
              </div>
            </div>
          </div>
          <div className={styles.bottom__line}></div>
          <div className={styles.privacy}>
            {data && <PortableBlock value={footerData!.privacy[0]} />}
          </div>
        </div>
      </Wrapper>
    </footer>
  );
};

export default Footer;
